import { InstallMethod } from '../lib/install'

/** The iOS share glyph — a box with an arrow out of the top — so the instruction matches what's on screen. */
function ShareGlyph() {
  return (
    <svg viewBox="0 0 16 16" className="inline-block w-3.5 h-3.5 -mt-0.5" aria-hidden>
      <path d="M8 1.5v8.5M5 4.5l3-3 3 3" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.5 7H4v7.5h8V7h-1.5" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  )
}

/**
 * A strip under the header offering to install the app. On a browser with a
 * real prompt it's a button; on an iPhone it can only say where the option is.
 */
export default function InstallBanner({
  method,
  onInstall,
  onDismiss,
}: {
  method: InstallMethod
  onInstall: () => void
  onDismiss: () => void
}) {
  return (
    <div className="px-4 sm:px-6 py-2 bg-accent-soft border-b border-accent/20 flex items-center justify-between gap-3">
      <p className="text-sm text-accent min-w-0">
        {method === 'prompt' ? (
          <>
            <strong className="font-medium">Install Snapshot Money</strong>
            <span className="hidden sm:inline"> — it opens in its own window, a tap away from your calendar.</span>
          </>
        ) : (
          <>
            <strong className="font-medium">Add it to your home screen:</strong> tap Share
            <ShareGlyph />, then “Add to Home Screen”.
          </>
        )}
      </p>
      <div className="flex items-center gap-3 shrink-0">
        {method === 'prompt' && (
          <button
            onClick={onInstall}
            className="px-3 py-1 text-xs rounded-sm bg-accent text-white hover:brightness-110"
          >
            Install
          </button>
        )}
        <button onClick={onDismiss} aria-label="Dismiss" className="text-accent hover:text-ink">
          ×
        </button>
      </div>
    </div>
  )
}
